import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../../services/api.service';
import { Subscription } from 'rxjs';
import { PermissionsService } from '../../../services/permission.service';

@Component({
  selector: 'app-user-mapping',
  standalone: false,
  templateUrl: './user-mapping.component.html',
  styleUrl: './user-mapping.component.scss'
})
export class UserMappingComponent implements OnInit, OnDestroy {
  cols: any[] = [
    { field: 'proposal_name', header: 'Proposal Name', filterType: 'text', width: '200px', minWidth: '150px', maxWidth: '300px' },
    // { field: 'proposal_step.id', header: 'Proposal Step', filterType: 'text' },
    // { field: 'proposal_step.name', header: 'Proposal Step Name', filterType: 'text' },
    { field: 'proposal_step.name', header: 'Proposal Step Name', filterType: 'text' , width: '200px', minWidth: '150px', maxWidth: '300px' },
    { field: 'user.first_name', header: 'First Name', filterType: 'text' , width: '200px', minWidth: '150px', maxWidth: '300px'},
    { field: 'user.last_name', header: 'Last Name', filterType: 'text' , width: '200px', minWidth: '150px', maxWidth: '300px' },
    { field: 'role.name', header: 'Role', filterType: 'text' , width: '200px', minWidth: '150px', maxWidth: '300px' },

  ];
  tableTitle = 'User Mapping';
  userData: any[] = [];
  showAddUserDialog: boolean = false;
  showEditUserDialog: boolean = false;
  showDeleteDialog: boolean = false;
  parentMenuOptions = [];
  selectedRole = null;
  userdropdownData = [];
  roledropdownData = [];
  proposaldropdownData = [];
  stepropdownData = [];
  menuForm!: FormGroup;
  private mySubscription = new Subscription();
  selectedUser: any;
  unitList: any
  constructor(
    private apiService: ApiService, private fb: FormBuilder, private messageService: MessageService,private permissionService: PermissionsService
  ) { }

  ngOnInit(): void {
    this.menuForm = this.fb.group({
      proposal: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9 &]+$')]],
      proposalStep: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9 &]+$')]],
      role: [''],
      user: [''],
      unit: [''],
      sequence: [{ value: '', disabled: true }],
      approved: [false]

    });
    this.menuForm.get('proposal')?.valueChanges.subscribe(value => {
      if (value) {
        this.getProposalStepData();
      } else {
        this.stepropdownData = []; // Clear dropdown if proposal is deselected
        this.menuForm.get('proposalStep')?.reset();
      }
    });

    // this.getProposalWorkflow();

  }
  ngOnDestroy() {
    if (this.mySubscription) {
      this.mySubscription.unsubscribe();
    }
  }
  addUser() {
    this.showAddUserDialog = true;
    this.menuForm.reset();
    this.menuForm.enable()
    this.getUnit()
    this.getUserData();
    this.getRoleData();
    this.getProposalData();
    this.getProposalStepData();
  }
viewMode = false;
viewSystem(user: any) {
  this.viewMode = true;
        this.showEditUserDialog = true;
  //  if (user && user.id) {
    this.selectedUser = user
    this.menuForm.reset();
    this.getUnit()
    this.getUserData();
    this.getRoleData();
    this.getProposalData();
    this.getProposalStepData();
    this.menuForm.patchValue({
      proposal: user.proposal_step.proposal,               // if user has proposal ID, this should be here
      proposalStep: user.proposal_step?.id,      // use the correct control name
      user: user.user?.id,
      role: user.role?.id,
      unit:user.unit,
      sequence: user.sequence,
      approved: false,
      status: 1
    }) 
    this.menuForm.disable()
    // }
}
  updateUser(user: any) {
    this.viewMode = false
    this.showEditUserDialog = true;
    this.menuForm.enable()
    this.selectedUser = user
    this.menuForm.reset();
    this.getUnit();
    this.getUserData();
    this.getRoleData();
    this.getProposalData();
    this.getProposalStepData();
    this.menuForm.patchValue({
      proposal: user.proposal_step.proposal,               // if user has proposal ID, this should be here
      proposalStep: user.proposal_step?.id,      // use the correct control name
      user: user.user?.id,
      role: user.role?.id,
      unit:user.unit,
      sequence: user.sequence,
      approved: false,
      status: 1
    })
     // 🔄 Delay filtering until after form patching completes
  // setTimeout(() => {
  //   const unitId = this.menuForm.get('unit')?.value?.id;
  //   this.userdropdownData = this.userListCopy.filter(u => u.unit?.id === unitId);
  // });
  }

  saveUpdatedMenu() {
   const formValue = this.menuForm.value;

      let payload;
      if (!formValue.approved) {
        payload = {
          status: 1,
          sequence: this.menuForm.get('sequence')?.value, // Convert level input to number
          proposal_step: this.menuForm.get('proposalStep')?.value,
          user: formValue.user,
          role: formValue.role,
          unit: formValue.unit,
          is_final_approve: formValue.approved || false
        };
      } else {
        let id = sessionStorage.getItem('user_role_id')
        payload = {
          proposal_step:  this.menuForm.get('proposalStep')?.value,
          user: parseInt(id),
          is_final_approve: formValue.approved || true
        }
      }
    const sub = this.apiService.putAPI(`/transaction/proposal-workflow/${this.selectedUser.id}/`, payload).subscribe({
      next: (res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'User mapping updated successfully.',
        });
        this.menuForm.reset();
        this.showEditUserDialog = false;
        this.getProposalWorkflow();
      },
      error: (err) => {
        console.error('Update failed:', err);
        // this.messageService.add({
        //   severity: 'error',
        //   summary: 'Error',
        //   detail: err?.error?.detail || 'Something went wrong while updating the mapping.',
        // });
      }
    });
    this.mySubscription.add(sub)
  }

  saveMenu() {
    if (this.menuForm.valid) {
      const formValue = this.menuForm.value;

      let payload;
      if (!formValue.approved) {
        payload = {
          status: 1,
          sequence: this.menuForm.get('sequence')?.value, // Convert level input to number
          proposal_step: this.menuForm.get('proposalStep')?.value,
          user: formValue.user,
          role: formValue.role,
          unit: formValue.unit,
          is_final_approve: formValue.approved || false
        };
      } else {
        let id = sessionStorage.getItem('user_role_id')
        payload = {
           proposal_step:  this.menuForm.get('proposalStep')?.value,
          user: parseInt(id),
          is_final_approve: formValue.approved || true
        }
      }


      const sub = this.apiService.postAPI('/transaction/proposal-workflow/', payload).subscribe({
        next: (res: any) => {

          this.userData = [...this.userData, res];

          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Mapping saved successfully'
          });

          this.menuForm.reset();
          this.showAddUserDialog = false;
          this.getProposalWorkflow();
        },
        error: (err) => {
          console.error('Error while saving mapping:', err);

          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error',
          //   detail: 'Failed to save mapping. Please try again.'
          // });
        }
      });
      this.mySubscription.add(sub)
    }
  }
  getUnit() {
    const sub = this.apiService.getAPI('/master/units/').subscribe((res: any) => {
      this.unitList = res.data;
    })
    this.mySubscription.add(sub)
  }
  getUserData() {
    const sub = this.apiService.getAPI('/account/users/').subscribe((res: any) => {
      this.userdropdownData = res.data;
      this.userListCopy = [...this.userdropdownData]
      // Now it's safe to filter
    const unitId = this.menuForm.get('unit')?.value;
    this.userdropdownData = this.userListCopy.filter(u => u.unit?.id === unitId);
    });
    this.mySubscription.add(sub)
  }
  getRoleData() {
    const sub = this.apiService.getAPI('/access/user-roles/').subscribe((res: any) => {
      let resp = res.data
      this.roledropdownData = resp;
       const rolePriority = ['INT', 'REC', 'APP'];  // desired order

    // Filter and sort
    this.roledropdownData = resp
      .filter(role => rolePriority.includes(role.code))
      .sort((a, b) => rolePriority.indexOf(a.code) - rolePriority.indexOf(b.code));
  });
    
    this.mySubscription.add(sub)
  }
  getProposalData() {
    const sub = this.apiService.getAPI('/master/proposals/').subscribe((res: any) => {
      this.proposaldropdownData = res.data
    });
    this.mySubscription.add(sub)
  }
  getProposalStepData() {
    let proposalId = this.menuForm.get('proposal').value
    if (!proposalId) return;
    const sub = this.apiService.getAPI(`/transaction/proposals/${proposalId}/steps/`).subscribe((res: any) => {
      this.stepropdownData = res;
    });
    this.mySubscription.add(sub)
  }
  totalRecords: number = 0;
  getProposalWorkflow(event: { page: number; search?: string } = { page: 1 }) {
    let unit_id = sessionStorage.getItem('unit_id')
    const page = event.page || 1;
    const search = event.search?.trim();

    let url = `/transaction/proposal-workflow/?page=${page}&unit=${unit_id}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    const sub = this.apiService.getAPI(url).subscribe((res: any) => {
      this.userData = res.results;
      this.totalRecords = res.count || 0
    });
    this.mySubscription.add(sub)
  }
  deleteUser(user: any) {
    this.showDeleteDialog = true;
    this.selectedUser = user
  }
  confirmDelete() {
    const sub = this.apiService.deleteAPI(`/transaction/proposal-workflow/${this.selectedUser.id}/`).subscribe({
      next: () => {
        this.userData = this.userData.filter(user => user.id !== this.selectedUser.id);
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Mapping deleted successfully'
        });
        this.showDeleteDialog = false;
        this.getProposalWorkflow();
      },
      error: (err) => {
        console.error('Delete failed:', err);
        // this.messageService.add({
        //   severity: 'error',
        //   summary: 'Error',
        //   detail: 'Failed to delete mapping. Please try again.'
        // });
      }
    });
    this.mySubscription.add(sub)
  }
  stepId: number | null = null;
  roleID: number | null = null;
  userID: number | null = null;
  userList: any;
  userListCopy: any;
  onRoleChange(event: any) {
    this.roleID = event.value;
    this.tryFetchingSequence();
  }

  onUserChange(event: any) {
    this.userID = event.value;
    this.tryFetchingSequence();
  }
  onUnitChange(event: any) {
    let unit_id = event.value
    this.userdropdownData = this.userListCopy.filter(user => user.unit?.id == unit_id);
  }
  tryFetchingSequence() {
    if (this.stepId && this.roleID && this.userID) {
      this.getSequence();
    }
  }

  getSequence() {
    this.apiService.getAPI(`/transaction/get-next-level/?proposal_step_id=${this.stepId}&role_id=${this.roleID}`)
      .subscribe((res: any) => {
        const sequenceValue = res.level ?? '';
        this.menuForm.get('sequence')?.patchValue(sequenceValue);
      });
  }
  onStepChange(event: any) {
    this.stepId = event.value;
    this.tryFetchingSequence();
  }
     get canEditSetup(): boolean {
  return this.permissionService.hasPrivilege('/setup', 'Edit') ||
         this.permissionService.hasPrivilege('/setup', 'Delete') ||
         this.permissionService.hasPrivilege('/setup', 'View');
} 
}
